import { useEffect, useRef } from "react";
import { GdkFooter } from "@gdk/footer";
import { useLocation } from "react-router-dom";

export default function GeaoFooter() {
    let gdkFooter = useRef();
    const location = useLocation();

    useEffect(() => {
        gdkFooter.current = new GdkFooter({
            "content": "#primary-footer"
        });
    }, []);

    const handleCookiePreferences = (e) => {
        e.preventDefault();
        if (window.OneTrust) {
            window.OneTrust.ToggleInfoDisplay();
        }
    };

    return (
        <footer id="primary-footer">
            <div className="footer-logo icon-geico"></div>

            <div className="footer-links">
                <ul className="footer-list">
                    <li><a href={`${location.pathname}#`} onClick={handleCookiePreferences} className="cutomerhost-cycle-footer-listitem ot-sdk-show-settings" data-link-name="primary-footer:Manage Cookie Preferences">
                        Manage Cookie Preferences
                    </a></li>
                </ul>
            </div>

            <div id="footer-copyright">GEICO © 1996-<span id="footerDate"></span></div>
        </footer>
    );
}